import styled, { css } from "styled-components";
import Spring from "../../components/Spring";

export const StyledSpring = styled(Spring)`
    margin-top: 50px;
    background-color: ${p => p.theme.c.snow};
    padding: 0 20px;
    overflow: hidden;

    .moderation-notice {
        display: none;
    }
`;

export const Categories = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 20px;
    ${p => p.theme.xs(css`
        grid-template-columns: auto;
    `)}
`;
